var _circle, _circle2, _g, _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalUsage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F7F9FB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 18.75,
    fill: "#336D91"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1834_15952)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5 30C46.5 30.3675 46.1891 30.6535 45.8219 30.6389L44.0353 30.5681C43.7337 30.5561 43.5 30.3019 43.5 30C43.5 29.6981 43.7337 29.4439 44.0353 29.4319L45.8219 29.3611C46.1891 29.3465 46.5 29.6325 46.5 30ZM44.2915 21.7481C44.4753 22.0658 44.3496 22.4691 44.0248 22.6399L42.439 23.4739C42.1732 23.6137 41.8453 23.5105 41.6949 23.2506C41.5445 22.9907 41.619 22.6558 41.8727 22.4951L43.3861 21.536C43.6961 21.3396 44.1077 21.4304 44.2915 21.7481ZM38.2519 15.7085C38.5696 15.8923 38.6604 16.3039 38.464 16.6139L37.5049 18.1273C37.3442 18.381 37.0093 18.4555 36.7494 18.3051C36.4895 18.1547 36.3863 17.8268 36.5261 17.561L37.3601 15.9752C37.5309 15.6504 37.9342 15.5247 38.2519 15.7085ZM30 13.5C30.3675 13.5 30.6535 13.8109 30.6389 14.1781L30.5681 15.9647C30.5561 16.2663 30.3019 16.5 30 16.5C29.6981 16.5 29.4439 16.2663 29.4319 15.9647L29.3611 14.1781C29.3465 13.8109 29.6325 13.5 30 13.5ZM21.7481 15.7085C22.0658 15.5247 22.4691 15.6504 22.6399 15.9752L23.4739 17.561C23.6137 17.8268 23.5105 18.1547 23.2506 18.3051C22.9907 18.4555 22.6558 18.381 22.4951 18.1273L21.536 16.6139C21.3396 16.3039 21.4304 15.8923 21.7481 15.7085ZM15.7085 21.7481C15.8923 21.4304 16.3039 21.3396 16.6139 21.536L18.1273 22.4951C18.381 22.6558 18.4555 22.9907 18.3051 23.2506C18.1547 23.5105 17.8268 23.6137 17.561 23.4739L15.9752 22.6399C15.6504 22.4691 15.5247 22.0658 15.7085 21.7481ZM14.1781 29.3611C13.8109 29.3465 13.5 29.6325 13.5 30C13.5 30.3675 13.8109 30.6535 14.1781 30.6389L15.9647 30.5681C16.2663 30.5561 16.5 30.3019 16.5 30C16.5 29.6981 16.2663 29.4439 15.9647 29.4319L14.1781 29.3611ZM15.7085 38.2519C15.5247 37.9342 15.6504 37.5309 15.9752 37.3601L17.561 36.5261C17.8268 36.3863 18.1547 36.4895 18.3051 36.7494C18.4555 37.0093 18.381 37.3442 18.1273 37.5049L16.6139 38.464C16.3039 38.6604 15.8923 38.5696 15.7085 38.2519ZM21.7481 44.2915C21.4304 44.1077 21.3396 43.6961 21.536 43.3861L22.4951 41.8727C22.6558 41.619 22.9907 41.5445 23.2506 41.6949C23.5105 41.8453 23.6137 42.1732 23.4739 42.439L22.6399 44.0248C22.4691 44.3496 22.0658 44.4753 21.7481 44.2915ZM30 46.5C29.6325 46.5 29.3465 46.1891 29.3611 45.8219L29.4319 44.0353C29.4439 43.7337 29.6981 43.5 30 43.5C30.3019 43.5 30.5561 43.7337 30.5681 44.0353L30.6389 45.8219C30.6535 46.1891 30.3675 46.5 30 46.5ZM38.2519 44.2915C37.9342 44.4753 37.5309 44.3496 37.3601 44.0248L36.5261 42.439C36.3863 42.1732 36.4895 41.8453 36.7494 41.6949C37.0093 41.5445 37.3442 41.619 37.5049 41.8727L38.464 43.3861C38.6604 43.6961 38.5696 44.1077 38.2519 44.2915ZM44.2915 38.2519C44.1077 38.5696 43.6961 38.6604 43.3861 38.464L41.8727 37.5049C41.619 37.3442 41.5445 37.0093 41.6949 36.7494C41.8453 36.4895 42.1732 36.3863 42.439 36.5261L44.0248 37.3601C44.3496 37.5309 44.4753 37.9342 44.2915 38.2519Z",
    fill: "#F7F9FB"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 36,
    width: 13.3,
    height: 1.9,
    rx: 0.950001,
    fill: "#F7F9FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1249 22.875L31.9958 31.6141C31.2258 32.926 29.4238 33.1567 28.3482 32.081C27.312 31.0448 27.4818 29.3198 28.7001 28.5056L37.1249 22.875Z",
    fill: "#F7F9FB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1834_15952",
    x: 9.5,
    y: 13.5,
    width: 41,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.764706 0 0 0 0 0.764706 0 0 0 0 0.764706 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1834_15952"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1834_15952",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUsage);
export default __webpack_public_path__ + "static/media/TotalUsage.016d022ebba40932dbd942faef120062.svg";
export { ForwardRef as ReactComponent };